// @ts-nocheck
/* eslint-disable */
export const stdSendMailIcon = {
    data: `<?xml version="1.0" encoding="UTF-8"?><svg viewBox="0 0 24 24" stroke-width="1.5" fill="none" xmlns="http://www.w3.org/2000/svg" color="currentColor"><path d="M9 9l4.5 3L18 9M3 13.5h2M1 10.5h4" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/><path d="M5 7.5V7a2 2 0 012-2h13a2 2 0 012 2v10a2 2 0 01-2 2H7a2 2 0 01-2-2v-.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/></svg>`,
    name: 'send-mail' as const
};